import script from "./ShowDepartments.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowDepartments.vue?vue&type=script&setup=true&lang=js"

import "./ShowDepartments.vue?vue&type=style&index=0&id=05843776&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05843776"]])

export default __exports__